"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUAccountConfig = void 0;
exports.BUAccountConfig = {
    DEBUG: false,
    RSAPublicKey: "-----BEGIN PUBLIC KEY-----\nMIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEApBlhi3vofEes0yDnVGEG\nUUNP2mH5l5YiTc7w8scI/CMIDwtAHsbmPbD4iID+eEtX5C3qcsX0ElzFg0l8eQZA\nOg3opTbS1Gf5xuFVtu9kvvbRtW0GWaPAZG9RMkpx7GN6FjaYecENz8plv7M4mfJP\n3V5lhontrMthjGxPNr/7VxadTjavoPRhxWFxP8vS/+rxvCPTVCVV7ScqcwRk7CUJ\nit0/AiPihZNDVKZwISgnLW4B3YnHtQ3iu7qcDmXQ8lIysxRU7PQLeG4xVr09mXh3\niXIT1Fj2OkHeXcCosK1OQYssnPDR7dWGzKHW/xR2KLrO7Grr/2H1Es2GbJ/6dNuq\nFTc6sE1QBYIWWvfsh4uBkPKoPQXdV2yY/e6TLF8lAFZiAyFsoe6MV8gEA6ygrHQ6\n3gzWiY+BylxxberAXG1rfgWw0OUyB+jN3X+VCpBSiuCaFvYpeyNnFy62kRfyTeiK\n8TCzYvRLXXzDmZnkCyySUmZ7f/0cPEehKylgqN0tRe6HywNmDEPEVFqL98tWSTpm\n0y3Y7BNGzAv2zCdxVNl+3PwXtGG/WblOT6aq59iQNLDfAYHQDj/oOhxsmXtuSX45\nl+RswU0WMauN+yUR0PVaPDPTYmlqpLuvIIqOuZr6jAyY30xEFtmWSHoJD83UO0+n\nE184rgCqr3YWQJCZnv5lzn0CAwEAAQ==\n-----END PUBLIC KEY-----",
    log: (content) => {
        if (!exports.BUAccountConfig.DEBUG) {
            return;
        }
        if (typeof content == "string") {
            console.log(content);
        }
        else {
            console.log(JSON.stringify(content));
        }
    },
};
